import { apiUrl } from "../constans";
import apiClient from '../libs/axios';
const userdata = {
    namespaced: true,
    state: {
        credentialMercadolibre: [],
        memberships: {
            data: [],
            current_page: 1,
            per_page: 1,
            last_page: 1,
            total: 0
        },
    },
    mutations: {
        setMemberships(state, memberships) {
            let stat = state.memberships;

            stat.data = memberships.data
            stat.current_page = memberships.current_page
            stat.per_page = memberships.per_page
            stat.total = memberships.total
            stat.last_page = memberships.last_page
        },

        setCurrentPage(state, page) {
            state.memberships.current_page = page
        },

        setCredentialMertcadolibre(state, data) {
            state.credentialMercadolibre = data
        },

        addObjectToArray(state, data) {
            state.memberships.data.push(data);
        },

        setUserdata(state, user) {
            const index = state.memberships.data.findIndex((item) => {
                return item.id === user.id
            })
            if (index) {
                state.memberships.data[index] = user;
            }
        }
    },
    getters: {
        getMemberships(state) {
            return state.memberships
        },

        getCredentialMercadolibreData() {
            return this.state.credentialMercadolibre
        }
    },

    actions: {

        getCredentialMercadolibre({ commit }) {
            // promesa para obtener las menbresias
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/mercadolibre/user-get-credential`)
                    .then(response => {

                        const credentials = response.data.data;
                        commit('setCredentialMertcadolibre', credentials);

                        resolve(credentials)

                    })
                    .catch(error => {
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });
        },
        // eslint-disable-next-line no-empty-pattern
        addCredentialMercadolibre( {}, data) {
            // promesa para obtener las menbresias
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/mercadolibre/user-add-credential`, data.data)
                    .then(() => {
                        resolve("Se registro correctamente")

                    })
                    .catch(error => {
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });
        },
        storeMemberships({ commit }, data) {
            // promesa para obtener las menbresias
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/membersheps?page=${data.page}`, data.filters)
                    .then(response => {

                        const membersheps = response.data.data;
                        commit('setMemberships', membersheps);
                        resolve("Inicio de session exitoso");
                    })
                    .catch(error => {
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });

        },

        toggleEstadoUser({ commit }, data) {
            // promesa para cambiar el estado del usuario
            return new Promise((resolve, reject) => {
                apiClient.put(`${apiUrl}/v2/users/${data.id}`, data)
                    .then(response => {
                        const userdata = response.data.data;
                        commit('setUserdata', userdata);
                        resolve("Estado del usuario actualizado exitosamente");
                    })
                    .catch(error => {
                        reject(error.response.data.errorMessage);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });
        },

        updateCountUser({ commit }, data) {
            // promesa para actualizar el conteo de usuarios
            const dataToSend = {
                amount: data.amount,
                plans_permission: data.plans_permission
            };
            return new Promise((resolve, reject) => {
                apiClient.put(`${apiUrl}/v2/payment_permission_count_users/${data.id}`, dataToSend)
                    .then(response => {
                        const userdata = response.data.data;
                        commit('setUserdata', userdata);
                        resolve("Cantidad de usuarios actualizada exitosamente");
                    })
                    .catch(error => {
                        reject(error.response.data.errorMessage);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });
        },

        exportMembresia() {
            // promesa para exportar las membresias como archivo
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/auth/kwcolombia/export `, { responseType: 'blob' })
                    .then(response => {
                        // Crear un enlace para descargar el archivo
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // Puedes cambiar el nombre del archivo aquí si lo deseas
                        link.setAttribute('download', 'membresias.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        storeUsers({ commit }, data) {
            // Simulación de una llamada asíncrona a la API de autenticación
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/users`, data)
                    .then(response => {
                        const userdata = response.data;

                        commit('addObjectToArray', userdata.data);
                        resolve(userdata.message);
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error.response.data.errorMessage);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });

        },

        getChildUsers(_, { userId, page = 1, filters = {} }) {
            const params = new URLSearchParams({ page, ...filters });
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/users/${userId}/children?${params}`)
                    .then(response => {
                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateUsers({ commit }, data) {
            // Simulación de una llamada asíncrona a la API de autenticación
            return new Promise((resolve, reject) => {
                apiClient.put(`${apiUrl}/v2/users/${data.id}`, data)
                    .then(response => {
                        const userdata = response.data;

                        commit('setUserdata', userdata.data);
                        resolve(userdata.message);
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error.response.data.errorMessage);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });

        },
    }
}

export default userdata;
